import React, { useEffect } from "react";
import swal from "sweetalert";
import { usePost } from "seed/api";
import { Loading } from "seed/helpers";
import l from "components/util/l";
import View from "components/vmisc/auth/VerifyEmail.view";

function VerifyEmail(props) {
  const { token } = props.match.params;
  if (!token) window.location.replace("/login")

  const [callVerifyToken, reqVerifyToken] = usePost("/users/check_signup_valid_token", {
    onError: (error) => {
      if (error.status == 404) {
        window.location.replace("/login");
      }
    },
    includeAuth: false,
  });

  const [callStartAccount, reqStartAccount] = usePost("/users/registry_verify", {
    onCompleted: () => {
      swal("Cuenta verificada exitosamente", "Tu cuenta ha sido verificada exitosamente, ya puedes iniciar sesión", "success")
        .then(() => {
          window.location.replace("/login");
        }).finally(() => {
          window.location.replace("/login");
        });
    },
    onError: (err) => {
      swal("Error al verificar cuenta", "Ha ocurrido un error al verificar tu cuenta, por favor intenta de nuevo mas tarde", "error");
    },
    includeAuth: false,
  });

  const [callGenerate, reqGenerate] = usePost("/users/registry_generate", {
    onCompleted: () => {
      swal(l("Verificación enviada%VB040"),
        l("Hemos enviado a tu correo el proceso para verificar tu cuenta, asegurate de verificarlo en los próximos 20 minutos%VB041"),
        "success")
    },
    onError: (err) => {
      swal("Error al generar link", "Ha ocurrido un error al generar el link de verificación, por favor intenta de nuevo mas tarde", "error");
    },
    includeAuth: false,
  });

  useEffect(() => {
    callVerifyToken({ token: token });
  }, []);

  if (reqVerifyToken.loading) return <Loading />;
  const verifyError = reqVerifyToken.error;
  const onClickGenerate = () => callGenerate({ token: token });

  const onClickVerifyAccount = (values) => {

    if (!values.firstName || !values.lastName || !values.password || !values.confirmPassword) {
      swal("Error", "Por favor complete todos los campos", "error");
      return;
    }

    // Check for password regex
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])\S{8,}$/;
    if (!passwordRegex.test(values.password)) {
      swal("Error", "La contraseña debe tener al menos 8 caracteres, incluyendo letras y números", "error");
      return;
    }

    if (values.password !== values.confirmPassword) {
      swal("Error", "Las contraseñas no coinciden", "error");
      return;
    }
    callStartAccount({
      token: token,
      firstName: values.firstName,
      lastName: values.lastName,
      password: values.password
    });
  }

  return <View verifyError={verifyError} onClickGenerate={onClickGenerate} onClickVerifyAccount={onClickVerifyAccount} />;
}

export default VerifyEmail;